import { Observable } from 'rxjs';

import { ChatConversacion } from '../../shared/interfaces/chat.interface';
import { ResolverSolicitudInput, ResumenDiscipulos } from './solicitudes.model';

/**
 * Contrato de datos de Solicitudes. Todas las operaciones devuelven la lista completa ya
 * actualizada para que la pantalla no tenga que reconstruir el estado.
 *
 * Se usa como token de DI. La pantalla provee `SolicitudesService` (HTTP).
 */
export abstract class SolicitudesDataSource {
  abstract listar(): Observable<ChatConversacion[]>;
  abstract enviarMensaje(personaId: string, nota: string): Observable<ChatConversacion[]>;
  abstract marcarLeidos(personaId: string): Observable<ChatConversacion[]>;
  abstract cerrarChat(personaId: string): Observable<ChatConversacion[]>;
  /** Cierra todos los chats sin solicitud pendiente. */
  abstract cerrarChats(): Observable<ChatConversacion[]>;
  abstract resolverSolicitud(input: ResolverSolicitudInput): Observable<ChatConversacion[]>;
  /** Líder y cantidad de discípulos directos, para decidir el envío al muelle. */
  abstract resumenDiscipulos(personaId: string): Observable<ResumenDiscipulos>;
}
